import { OrganizationSettingsDTOPricingRuleEnum } from '@reposit/api-client';

export const cappedPricingRules = [
  OrganizationSettingsDTOPricingRuleEnum.STANDARDCAP250,
  OrganizationSettingsDTOPricingRuleEnum.STANDARDCAP300,
  OrganizationSettingsDTOPricingRuleEnum.STANDARDCAP350,
];

export const isCappedPricingRule = (pricingRule?: OrganizationSettingsDTOPricingRuleEnum): boolean =>
  !!pricingRule && cappedPricingRules.indexOf(pricingRule) !== -1;
